import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleCreateNewSupplement } from './actions';
import { ICreateNewSupplementState } from './slice.interface';

const initialState: ICreateNewSupplementState = {
  data: null,
  isLoading: false,
};

export const createNewSupplementSlice = createSlice({
  name: 'create-new-supplement',
  initialState,
  reducers: {
    removeAddSupplement: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleCreateNewSupplement.pending, (state: ICreateNewSupplementState) => {
        state.isLoading = true;
      })
      .addCase(handleCreateNewSupplement.fulfilled, (state: ICreateNewSupplementState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        eventBus.emit(EventType.CREATE_NEW_SUPPLEMENT_SUCCESS);
      });
  },
});

export const { removeAddSupplement } = createNewSupplementSlice.actions;

export default createNewSupplementSlice.reducer;
